export function addVariationsToProducts() {
    const products = document.querySelectorAll('li.product')
    if (!products || !products.length) return

    const fallbackQty = parseFloat(liGlobal.defaultProductQty) || 0

    for (const product of products) {
        const buttons = product.querySelectorAll('.loop-variation-button')
        if (!buttons || !buttons.length) continue

        // 1) If someone is already selected (e.g. WC default via PHP/precompute), respect it.
        let hasSelected = false
        for (const btn of buttons) {
            if (btn.classList.contains('selected')) {
                hasSelected = true
                handleVariationSelection(btn)
                break
            }
        }
        if (hasSelected) continue

        // 2) Otherwise: select first that matches fallback
        let chosen = null
        for (const btn of buttons) {
            const v = parseFloat(btn.dataset.variationValue)
            if (!Number.isFinite(v)) continue
            if (v >= fallbackQty) {
                chosen = btn
                break
            }
        }

        // 3) If none >=, select first (so you always have one selected)
        if (!chosen) chosen = buttons[0]

        chosen.classList.add('selected')
        handleVariationSelection(chosen)
    }
}

document.addEventListener('DOMContentLoaded', function () {
    addVariationsToProducts()
})

// Lägg in variations på resultaten från relevanssi live ajax search när de har laddats klart
if (window.jQuery) {
    var lastHtml = ''

    jQuery(document).on('relevanssi_live_search_shutdown', function (e, $input, $results) {
        if (!$results || !$results.length) return

        var $ajax = $results.find('.ajax-results')
        if (!$ajax.length) return

        var html = ($ajax.html() || '').trim()
        if (!html) return
        if (html === lastHtml) return

        lastHtml = html

        addVariationsToProducts()
    })
}

export function handleVariationSelection(button) {
    const product = button.closest('li.product')
    if (!product) return

    const buttonShowVariations = product.querySelector('.btn-show-variations')
    if (!buttonShowVariations) return

    const variationValueEl = button.querySelector('.variation-value')
    if (!variationValueEl) return

    const variationText = variationValueEl.textContent.trim()
    const shortVariationText = variationText.replace(/(\d+)-p.*/i, '$1-p')

    const btnShowVariationPrice = buttonShowVariations.querySelector('.btn-show-variation-price')
    const btnShowVariationName = buttonShowVariations.querySelector('.btn-show-variation-name')
    const btnShowVariationUnitPrice = buttonShowVariations.querySelector('.btn-show-variation-unit-price')

    const priceEl = button.querySelector('.price')
    const unitPriceEl = button.querySelector('.unit-price')

    const lwLoopAddToCart = button.closest('.lw-loop-add-to-cart')
    const variationId = button.dataset.variationId || null
    const attrs = button.dataset.attrs || null

    if (lwLoopAddToCart) {
        lwLoopAddToCart.setAttribute('data-selected-variation-id', variationId)
        lwLoopAddToCart.setAttribute('data-selected-attrs', attrs)
    }
    if (btnShowVariationPrice && priceEl) btnShowVariationPrice.textContent = priceEl.textContent
    if (btnShowVariationName) btnShowVariationName.textContent = shortVariationText

    if (btnShowVariationUnitPrice) {
        const unitText = unitPriceEl ? unitPriceEl.textContent.trim() : ''
        btnShowVariationUnitPrice.textContent = unitText || ''
    }
}

document.addEventListener('click', function (e) {
    const btn = e.target.closest('.loop-variation-button')
    if (!btn) return

    const product = btn.closest('li.product')
    product &&
        product.querySelectorAll('.loop-variation-button.selected').forEach((b) => b.classList.remove('selected'))
    btn.classList.add('selected')

    handleVariationSelection(btn)
})
